export const Side = {
  BUY: "buy",
  SELL: "sell"
} as const;

export type Side = (typeof Side)[keyof typeof Side];

export type FormattedOrderBookChange = {
  side: Side;
  price: number;
  quantity: number;
  cmlQuantity?: number;
};

export type FormattedOrderBook = {
  asks: FormattedOrderBookChange[];
  bids: FormattedOrderBookChange[];
};

export type OrderBookChange = [Side, string, string];

export const WEBSOCKET_URL = "wss://api.gemini.com/v2/marketdata";

export const REFRESH_RATE_MS = 500;

export const BUCKET_SIZE = 7;
